<div class="profile-modal-container">
    <!-- Header -->
    <div class="modal-header p-4 border-bottom d-flex justify-content-between align-items-center">
        <div>
            <h2 class="m-0 fw-bold text-gradient">👤 Mi Perfil</h2>
            <p class="text-secondary m-0 small">Gestiona tu información</p>
        </div>
        <button class="btn-close-custom" (click)="dialogRef.close()">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <!-- Scrollable Body -->
    <div class="modal-body p-0" style="max-height: 80vh; overflow-y: auto;">
        <div class="container-fluid p-4">
            <div class="row g-4">
                <!-- User Card -->
                <div class="col-md-5">
                    <div class="card profile-card h-100 border-0 shadow-sm">
                        <div class="card-body text-center p-4">
                            <div class="profile-avatar mb-3">
                                <i class="fas fa-user-circle"></i>
                            </div>
                            <h4 class="fw-bold mb-1 show-name">{{ user?.nombre || user?.username || 'Usuario' }}</h4>
                            <p class="text-muted mb-3">{{ user?.username }}</p>
                            <div class="role-badge mb-2">
                                <i class="fas fa-shield-alt me-2"></i>
                                {{ user?.rolNombre || 'Usuario' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Password Form -->
                <div class="col-md-7">
                    <div class="card form-card h-100 border-0 shadow-sm">
                        <div class="card-header bg-transparent border-bottom px-4 py-3">
                            <h5 class="fw-bold m-0"><i class="fas fa-key me-2 text-primary"></i>Cambiar Contraseña</h5>
                        </div>
                        <div class="card-body p-4">
                            <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">

                                <div class="mb-3">
                                    <label class="form-label small fw-bold">Contraseña Actual</label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted">
                                            <i class="fas fa-lock"></i>
                                        </span>
                                        <input [type]="hideCurrent ? 'password' : 'text'"
                                            class="form-control border-start-0" formControlName="currentPassword"
                                            placeholder="••••••">
                                        <button type="button" class="btn btn-outline-secondary border-start-0"
                                            (click)="hideCurrent = !hideCurrent">
                                            <i class="fas" [ngClass]="hideCurrent ? 'fa-eye' : 'fa-eye-slash'"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label small fw-bold">Nueva Contraseña</label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted">
                                            <i class="fas fa-key"></i>
                                        </span>
                                        <input [type]="hideNew ? 'password' : 'text'"
                                            class="form-control border-start-0" formControlName="newPassword"
                                            placeholder="Mínimo 6 caracteres">
                                        <button type="button" class="btn btn-outline-secondary border-start-0"
                                            (click)="hideNew = !hideNew">
                                            <i class="fas" [ngClass]="hideNew ? 'fa-eye' : 'fa-eye-slash'"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="mb-4">
                                    <label class="form-label small fw-bold">Confirmar</label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted">
                                            <i class="fas fa-check-circle"></i>
                                        </span>
                                        <input [type]="hideConfirm ? 'password' : 'text'"
                                            class="form-control border-start-0" formControlName="confirmPassword"
                                            placeholder="Repetir contraseña">
                                        <button type="button" class="btn btn-outline-secondary border-start-0"
                                            (click)="hideConfirm = !hideConfirm">
                                            <i class="fas" [ngClass]="hideConfirm ? 'fa-eye' : 'fa-eye-slash'"></i>
                                        </button>
                                    </div>
                                    <div *ngIf="passwordForm.errors?.['mismatch'] && passwordForm.get('confirmPassword')?.touched"
                                        class="form-text text-danger mt-1">
                                        <i class="fas fa-exclamation-circle me-1"></i>Las contraseñas no coinciden.
                                    </div>
                                </div>

                                <div class="d-grid">
                                    <button type="submit" class="btn btn-primary fw-bold"
                                        [disabled]="passwordForm.invalid || isLoading">
                                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                                        {{ isLoading ? 'Actualizando...' : 'Actualizar Contraseña' }}
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>